export default __webpack_public_path__ + "static/media/chani happy.442712ab.svg";